import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LandingHeader from './LandingHeader';
import Footer from './Footer';
import footerPages from './footerPages';
import './InfoPage.css';

const InfoPage = ({ slug }) => {
  const navigate = useNavigate();
  const page = footerPages.find((p) => p.slug === slug);

  // Scroll to top when navigating between info pages
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!page) {
    return (
      <>
        <LandingHeader showFeatures={false} />
        <div className="info-page">
          <h1>Page not found</h1>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <LandingHeader showFeatures={false} />
      <main className="info-page">
        <div className="info-card">
          <p className="info-breadcrumb" onClick={() => navigate('/')}>
            Home
          </p>
          <h1 className="info-title">{page.title}</h1>
          {page.note && <p className="info-note">{page.note}</p>}

          <ul className="info-points">
            {page.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default InfoPage;
